"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _isArray = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/array/is-array"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _QuizTournamentTeamChooser = _interopRequireDefault(require("./QuizTournamentTeamChooser.scss"));

var _index = _interopRequireDefault(require("../Button/index.js"));

var _QuizTournamentStrings = require("./QuizTournamentStrings");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _QuizTournament = require("./QuizTournament");

var _ErrorHelper = require("../../../helpers/ErrorHelper");

var _AlertHelper = require("../../../helpers/AlertHelper");

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var QuizTournamentTeamChooser = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(QuizTournamentTeamChooser, _React$Component);

  var _super = _createSuper(QuizTournamentTeamChooser);

  function QuizTournamentTeamChooser(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, QuizTournamentTeamChooser);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "chooseTeam", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(team) {
        var errorMessage;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.props.chooseTeam(team);

              case 3:
                _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_MY_TEAM_NAME, team.name, false);

                _this.setState({
                  selectedTeam: team
                });

                _context.next = 11;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);
                errorMessage = (0, _ErrorHelper.getErrorMessage)(_context.t0);
                (0, _AlertHelper.showWideAlertHtml)(errorMessage, (0, _QuizTournamentStrings.getString)('FAILURE'));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 7]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "checkIfMemberOfTeam", function (tournament, userId) {
      if (tournament.hasOwnProperty('teams') && (0, _typeof2["default"])(tournament['teams']) === 'object') {
        for (var _i = 0, _Object$values = (0, _values["default"])(tournament['teams']); _i < _Object$values.length; _i++) {
          var team = _Object$values[_i];

          if (team.hasOwnProperty('members') && (0, _isArray["default"])(team['members'])) {
            var user = team['members'].find(function (member) {
              return member.id === userId;
            });

            if (user) {
              return team;
            }
          }
        }
      }

      return null;
    });
    _this.state = {
      selectedTeam: null
    };
    return _this;
  }

  (0, _createClass2["default"])(QuizTournamentTeamChooser, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.userId && this.props.tournamentData) {
        var currentTeam = this.checkIfMemberOfTeam(this.props.tournamentData, this.props.userId);

        if (currentTeam) {
          this.setState({
            selectedTeam: currentTeam
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var teams = this.props.tournamentData['teams'] || {};
      var chosenTeam = null;

      if (this.props.tournamentData.teams && this.state.selectedTeam && this.state.selectedTeam.name) {
        console.log(' set chosenTeam', this.props.tournamentData.teams[this.state.selectedTeam.name]);
        chosenTeam = this.props.tournamentData.teams[this.state.selectedTeam.name];
      }

      var leaveBtn = this.props.phase === _QuizTournament.TOURNAMENT_PHASES.CHOOSE_TEAM ? /*#__PURE__*/_react["default"].createElement(_index["default"], {
        theme: 'dark',
        className: _QuizTournamentTeamChooser["default"].leaveBtn,
        onClick: this.props.leaveTournament
      }, (0, _QuizTournamentStrings.getString)('TOURNAMENT_LEAVE')) : null;
      var content = this.props.phase === _QuizTournament.TOURNAMENT_PHASES.CHOOSE_TEAM ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentTeamChooser["default"].mainTeamWrapper
      }, (0, _values["default"])(teams).map(function (team) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: team.name,
          className: _QuizTournamentTeamChooser["default"].teamWrapper
        }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
          theme: _this2.state.selectedTeam && team.name === _this2.state.selectedTeam.name ? 'blue' : 'dark',
          width: '100%',
          onClick: _this2.props.phase === _QuizTournament.TOURNAMENT_PHASES.CHOOSE_TEAM ? function () {
            return _this2.chooseTeam(team);
          } : function () {}
        }, team.name), /*#__PURE__*/_react["default"].createElement("div", {
          className: _QuizTournamentTeamChooser["default"].teamAmountMembers
        }, (0, _QuizTournamentStrings.getString)('TOURNAMENT_MEMBER_AMOUNT_TEAM')), /*#__PURE__*/_react["default"].createElement("div", null, team.members.length));
      })) : /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentTeamChooser["default"].mainTeamWrapper
      }, chosenTeam ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentTeamChooser["default"].singleTeamWrapper
      }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
        theme: 'blue',
        width: '100%',
        onClick: function onClick() {}
      }, this.state.selectedTeam.name), chosenTeam.members.length > 1 && [/*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentTeamChooser["default"].teamMembers
      }, "Du spielst zusammen mit:"), /*#__PURE__*/_react["default"].createElement("div", null, chosenTeam.members.map(function (member) {
        if (member.id !== _this2.props.user.id) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: member.id
          }, member.nickname);
        }
      }))]) : /*#__PURE__*/_react["default"].createElement(_Spinner["default"], null));
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentTeamChooser["default"].mainWrapper
      }, leaveBtn, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentTeamChooser["default"].heading
      }, this.props.phase === _QuizTournament.TOURNAMENT_PHASES.CHOOSE_TEAM ? (0, _QuizTournamentStrings.getString)('CHOOSE_TEAM') : (0, _QuizTournamentStrings.getString)('WAITING_FOR_TOURNAMENT_START')), content, /*#__PURE__*/_react["default"].createElement("div", {
        className: _QuizTournamentTeamChooser["default"].lowerWrapper
      }, /*#__PURE__*/_react["default"].createElement(_index["default"], {
        className: _QuizTournamentTeamChooser["default"].infoBtn,
        theme: 'blue',
        disabled: !this.state.selectedTeam
      }, this.state.selectedTeam ? [(0, _QuizTournamentStrings.getString)('WAITING_FOR_TOURNAMENT_START'), /*#__PURE__*/_react["default"].createElement("span", null), /*#__PURE__*/_react["default"].createElement("span", null), /*#__PURE__*/_react["default"].createElement("span", null)] : (0, _QuizTournamentStrings.getString)('WAITING_FOR_TEAM_CHOICE'))));
    }
  }]);
  return QuizTournamentTeamChooser;
}(_react["default"].Component);

QuizTournamentTeamChooser.propTypes = {
  leaveTournament: _propTypes["default"].func.isRequired,
  chooseTeam: _propTypes["default"].func.isRequired,
  tournamentData: _propTypes["default"].object.isRequired,
  phase: _propTypes["default"].string.isRequired,
  user: _propTypes["default"].object.isRequired
};
var _default = QuizTournamentTeamChooser;
exports["default"] = _default;